import SV from 'server-vars';
import { VisitCountModel } from 'dibs-visit-tracking';
import { getUserToken } from 'dibs-cookie-jar';

import FollowSuggestionModal from '../../../finding/components/FollowSuggestionModal/FollowSuggestionModal';
import { isPageType, pageTypes, autoModalHelpers } from 'dibs-buyer-layout/src/entries/index';

import { benefitsModalTest, benefitsModalShow } from '../benefitsModalHelper.es';

const { setModalShown, wasModalShown, loadAutoModal } = autoModalHelpers;

const { BROWSE_TYPES } = pageTypes;

export const MODAL_TYPE = 'followSuggestionModal';
/**
 * Checks page type.
 * @returns {boolean}
 */
const isAllowedPageType = () => {
    return isPageType(BROWSE_TYPES);
};

/**
 * Checks if all tests succeeds
 * @returns {boolean}
 */
const shouldShowModal = () => {
    const isLoggedOut = !getUserToken(document.cookie);
    const searchCanBeSaved = SV.get('data.saveSearch');
    const visitCountModel = new VisitCountModel();
    const timeToShow = visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
    return isLoggedOut && searchCanBeSaved && isAllowedPageType() && timeToShow && !wasModalShown();
};

const openFollowSuggestionModal = context => {
    setModalShown();

    loadAutoModal({
        AutoModal: FollowSuggestionModal,
        modalProps: { context },
    });
};

export const followSuggestionModalRule = ({ context }) => {
    if (shouldShowModal()) {
        return benefitsModalTest({ modalType: MODAL_TYPE })
            .then(() => {
                benefitsModalShow();
                return Promise.resolve({ success: true, type: 'benefitsModal' });
            })
            .catch(() => {
                openFollowSuggestionModal(context);
                return Promise.resolve({ success: true, type: MODAL_TYPE });
            });
    }

    return Promise.resolve();
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/followSuggestionModalRule.es.js